import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import { MDBRow, MDBCol, MDBContainer } from 'mdbreact';
import {
  Button,
  DateTimePicker,
  FileSelector,
  Option,
  Picklist,
  Textarea,
} from 'react-rainbow-components';
import 'react-quill/dist/quill.snow.css';
import { QuillModules } from '../shared/QuillOptions';
import { Commune } from '../../interfaces/Commune_interface';
import { RequestInit } from '../shared/RequestInit';
import { DateTimeFormatter } from '../shared/DateTimeFormatter';
import { DefaultDateTime, DefaultEndDateTime } from '../shared/DateTime';
import Preview from '../shared/Preview';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import ShowNotification from '../shared/Notification';
import { PicklistInterface } from '../../interfaces/Picklist_interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import onImageLoad from '../shared/crop/helpers/default-crop/default-crop';
import { canvasPreview } from '../shared/crop/helpers/canvas-preview/canvas-preview';
import useDebounceEffect from '../shared/crop/hooks/use-debounce-effect/useDebounceEffect';

const CreateAgenda = () => {
  const [Titre, setTitre] = useState<string>('');
  const [Text_Complet, setText_complet] = useState<string>('');
  const [Commune, setCommune] = useState<Commune[]>([]);
  const [Commune_Preview, setCommune_Preview] =
    useState<string>("Braine-l'Alleud");
  const [Commune_ID, setCommune_ID] = useState(1);
  const [Image, setImage] = useState<Blob | string>('');
  const [UploadedImage, setUploadeImage] = useState<string>('');
  const [Date_Debut, setDate_Debut] = useState<string>(DefaultDateTime);
  const [Date_Fin, setDate_Fin] = useState<string>(DefaultEndDateTime);
  const [DropdownState, setDropdownState] = useState<PicklistInterface>({
    name: 'option1',
    label: "Braine-l'Alleud",
  });
  const [Date_Evenement, setDate_Evenement] = useState(DefaultDateTime);

  /* state for crop logic */
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const [aspect, setAspect] = useState<number>(21 / 9);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const imageRef = useRef<HTMLImageElement>(null);
  const blobUrlRef = useRef('');
  const [blobUrl, setBlobUrl] = useState('');
  const [ImageCrop, setImageCrop] = useState<Blob | string>('');

  /* state for each input field where we set the error message*/
  const [errorTitre, setErrorTitre] = useState<string>('');
  const [errorImage, setEerrorImage] = useState<string>('');
  const [UploadError, setUploadError] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);

  const history = useHistory();

  /* function to verify that all required input fields are not empty */
  const verifyInput = () => {
    /* initial */
    let isGood: boolean = true;
    if (Titre === '') {
      setErrorTitre('Le titre est obligatoire');
      isGood = false;
    }
    if (Image === '') {
      setEerrorImage(`L'image est obligatoire`);
      isGood = false;
    }
    /* if required fields are not empty, return true otherwise return false */
    if (isGood) {
      return true;
    } else {
      return false;
    }
  };

  /* functio that resets all errors message to be empty */
  const resetInputErrors = () => {
    setUploadError(false);
    setErrorTitre('');
    setEerrorImage('');
  };
  useEffect(() => {
    const fetchCommune = async () => {
      await fetch(
        'https://admin.radioemotion.be/api/commune/get',
        RequestInit as RequestInit
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.response === true) {
            setCommune(response.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchCommune();
  }, []);

  /* submit function to create the evenement  */
  const CreateActualite = () => {
    /* call the function to reset errors messages */
    resetInputErrors();
    if (verifyInput() === true) {
      const sendDate = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', ImageCrop);
        formData.append(
          'data',
          JSON.stringify({
            Titre: Titre,
            Date_Debut: Date_Debut,
            Date_Fin: Date_Fin,
            Date_Evenement: Date_Evenement,
            Text_Complet: Text_Complet,
            FK_Commune: Commune_ID,
          })
        );
        const requestOptions = {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        };
        await fetch(
          'https://admin.radioemotion.be/api/agenda/create',
          requestOptions as RequestInit
        )
          .then((response) => response.json())
          .then((response) => {
            setLoading(false);
            if (response.response === true) {
              history.push({
                pathname: '/agenda/list',
                state: { passed: true, message: `L'evenement a été créé` },
              });
            } else {
              setUploadError(true);
            }
          })
          .catch((err) => {
            setLoading(false);
            setUploadError(true);
          });
      };
      sendDate();
    }
  };
  async function onDownloadCropClick() {
    const image = imageRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );

    const blob = await offscreen.convertToBlob({
      type: 'image/png',
    });
    setImageCrop(blob);

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);
    setBlobUrl(blobUrlRef.current);
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imageRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imageRef.current,
          previewCanvasRef.current,
          completedCrop,
          1,
          0
        );
        onDownloadCropClick();
      }
    },
    100,
    [completedCrop]
  );

  return (
    <>
      {UploadError ? (
        <>
          <ShowNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="color-red background-color-red text-white"
            autohide={5000}
            title=""
            message="Une erreur s'est produite"
            text="maintenant"
          />
        </>
      ) : null}
      <MDBContainer className="min-h-100vh">
        <MDBRow className="mb-5 mt-2">
          <Link to="/">
            <Button variant="neutral" className="mt-2">
              <FontAwesomeIcon icon={faHome} className="py-1" size="2x" />
            </Button>
          </Link>
        </MDBRow>
        <MDBRow>
          <form encType="multipart/form-data" className="w-100">
            <MDBRow>
              <MDBCol className="w-100 mb-5 mx-auto">
                <Textarea
                  id="actualiteCreateTitre"
                  label="Titre de l'evenement "
                  rows={2}
                  placeholder="Titre de l'evenement"
                  grow={true}
                  onChange={(e) => {
                    setTitre(e.target.value);
                    {
                      e.target.value === ''
                        ? setErrorTitre('Le titre est obligatoire')
                        : setErrorTitre('');
                    }
                  }}
                  value={Titre}
                  error={errorTitre}
                />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol className="w-100 mb-5 mx-auto">
                <label
                  htmlFor="TextEditor"
                  className="text-center w-100"
                  id="actualiteCreateTextComplet"
                >
                  Texte complet de l'evenement{' '}
                </label>
                <ReactQuill
                  theme="snow"
                  onChange={setText_complet}
                  modules={QuillModules}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md={'4'} xs={'12'} sm={'12'}>
                <FileSelector
                  label="Selecteur de fichier"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setImage(value[0]);
                    setUploadeImage(URL.createObjectURL(value[0]));
                  }}
                  error={errorImage}
                />
              </MDBCol>
              <MDBCol md={'4'} xs={'12'} sm={'12'}>
                <Picklist
                  onChange={(value) => {
                    setCommune_Preview(Commune[parseInt(value.value) - 1].name);
                    setCommune_ID(value.value);
                    setDropdownState({ name: value.name, label: value.label });
                  }}
                  placeholder="Choisissez la ville"
                  label="Choisissez la ville"
                  name="Ville"
                  variant="default"
                  value={DropdownState}
                >
                  {Commune.map((data: Commune) => (
                    <Option
                      key={data.Id}
                      name={`option${data.Id}`}
                      label={data.name}
                      value={data.Id}
                    />
                  ))}
                </Picklist>
              </MDBCol>
              <MDBCol md={'4'} xs={'12'} sm={'12'}>
                <DateTimePicker
                  value={Date_Evenement}
                  formatStyle={'large'}
                  locale="fr"
                  label="Date de l'evenement"
                  onChange={(value) => {
                    setDate_Evenement(DateTimeFormatter(value, false));
                    setDate_Fin(
                      DateTimeFormatter(
                        new Date(value.setHours(23, 59, 59, 0)),
                        false
                      )
                    );
                  }}
                  hour24={true}
                />
              </MDBCol>
            </MDBRow>
          </form>
        </MDBRow>
        {Image && (
          <>
            <MDBCol className="text-center mb-4 mt-5">
              <hr />
              <h1 className="font-size-1vw">
                Veuillez sélectionner le cadrage pour l'image
              </h1>
            </MDBCol>
            <MDBRow>
              <MDBCol>
                <ReactCrop
                  className="w-100"
                  crop={crop}
                  aspect={21 / 9}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  onComplete={(c) => {
                    setCompletedCrop(c);
                  }}
                >
                  <img
                    src={UploadedImage}
                    style={{ width: '100%' }}
                    ref={imageRef}
                    crossOrigin="anonymous"
                    onLoad={(e) => onImageLoad(e, { aspect, setCrop })}
                  />
                </ReactCrop>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
                <div>
                  <canvas
                    ref={previewCanvasRef}
                    style={{
                      display: 'none',
                    }}
                  />
                </div>
              </MDBCol>
            </MDBRow>
          </>
        )}
        {Commune.length > 0 ? (
          <MDBRow>
            <MDBCol className="preview">
              <Preview
                Titre={Titre}
                TextComplet={Text_Complet}
                Image={blobUrl !== '' ? blobUrl : UploadedImage}
                DateDebut={Date_Debut}
                DateFin={Date_Fin}
                DateEvenement={Date_Evenement}
                Commune={{ name: Commune_Preview }}
              ></Preview>
            </MDBCol>
          </MDBRow>
        ) : (
          <MDBRow>
            <MDBCol></MDBCol>
          </MDBRow>
        )}
        <MDBRow end>
          <Button
            isLoading={loading}
            label="Créer"
            onClick={() => CreateActualite()}
            variant="brand"
            className="mt-2 mb-4 font-weight-bold"
          />
        </MDBRow>
      </MDBContainer>
    </>
  );
};

export default CreateAgenda;
